// Applies a config-driven pattern (e.g. "MM:SS", "HH:MM:SS.mm") to hh/mm/ss/centisecond parts.
const applyTimePattern = (
  format: string | undefined,
  hh: string,
  mm: string,
  ss: string,
  cs: string,
  fallback: string
): string => {
  if (!format) return fallback;
  return format
    .replace(/HH/g, hh)
    .replace(/MM/g, mm)
    .replace(/SS/g, ss)
    .replace(/mm/g, cs);
};

export const formatCompletedTaskTime = (value: unknown, format?: string): string => {
  const rawValue = String(value ?? '').trim();
  if (!rawValue) return '';

  const parts = rawValue.replace('.', ':').split(':').map((part) => part.trim());
  if (parts.length < 2 || parts.length > 4 || parts.some((part) => !/^\d+$/.test(part))) {
    return rawValue;
  }

  const [hoursStr, minutesStr, secondsStr = '0', millisecondsStr = '0'] = parts;
  const hours = hoursStr.padStart(2, '0');
  const minutes = minutesStr.padStart(2, '0');
  const seconds = secondsStr.padStart(2, '0');
  const milliseconds = millisecondsStr.padStart(2, '0');
  const fallback = [hours, minutes, seconds, milliseconds].join(':');

  return applyTimePattern(format, hours, minutes, seconds, milliseconds, fallback);
};

// Formats a duration in milliseconds (e.g. video playback position) using the same config-driven pattern.
export const formatMsToPattern = (ms: number, format?: string): string => {
  const totalMs = Math.max(0, Math.floor(ms || 0));
  const totalSeconds = Math.floor(totalMs / 1000);
  const cs = String(Math.floor((totalMs % 1000) / 10)).padStart(2, '0');
  const hh = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const mm = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const ss = String(totalSeconds % 60).padStart(2, '0');
  const fallback = `${hh}:${mm}:${ss}.${cs}`;

  return applyTimePattern(format, hh, mm, ss, cs, fallback);
};